import { render, staticRenderFns } from "./NewEditorModal.vue?vue&type=template&id=5e64d9c4&scoped=true"
import script from "./NewEditorModal.vue?vue&type=script&lang=js"
export * from "./NewEditorModal.vue?vue&type=script&lang=js"
import style0 from "./NewEditorModal.vue?vue&type=style&index=0&id=5e64d9c4&prod&lang=css"
import style1 from "./NewEditorModal.vue?vue&type=style&index=1&id=5e64d9c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e64d9c4",
  null
  
)

export default component.exports